module.exports = __webpack_public_path__ + "img/generic_logo.fc1dae21.png";